// extracted by mini-css-extract-plugin
export default {"SignUp":"ThankYou_SignUp__4KPeA","Border":"ThankYou_Border__PAUsr","InputClass":"ThankYou_InputClass__f6J69","Button":"ThankYou_Button__Lky+S","Image":"ThankYou_Image__RMo46"};